// Shared Framer Motion variants to ensure DRY principles

export const containerVariants = (staggerChildren = 0.1, delayChildren = 0.05) => ({
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren,
      delayChildren
    }
  }
});

export const fadeUpVariants = (y = 25, duration = 0.6, ease = [0.16, 1, 0.3, 1]) => ({
  hidden: { opacity: 0, y },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration, ease }
  }
});

export const fadeLeftVariants = (x = -20, duration = 0.6) => ({
  hidden: { opacity: 0, x },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration, ease: 'easeOut' }
  }
});
